export const samedayStatusConfig = {
  // Status mapping
  statusMapping: {
    // Normal Delivery Flow
    1: "REGISTERED", // Comandă înregistrată
    2: "IN_TRANSIT", // În curs de ridicare
    3: "IN_TRANSIT", // Colet ridicat
    4: "IN_TRANSIT", // Ridicată de la client
    5: "IN_TRANSIT", // În depozit
    6: "IN_TRANSIT", // În curs de livrare
    7: "DELIVERED", // Livrat

    // Failed Delivery Attempts
    8: "FAILED", // Livrare eșuată
    9: "DELIVERED", // Livrata cu succes
    11: "FAILED", // Refuz de primire

    // Cancellations and Issues
    15: "CANCELED", // Comandă anulată
    16: "CANCELED", // Comandă respinsă
    17: "CANCELED", // Comandă expirată

    // Locker/PUDO Services
    20: "PENDING", // În așteptare încărcare în easybox
    21: "IN_TRANSIT", // Încărcat în easybox
    22: "DELIVERED", // Ridicat din easybox
    23: "IN_TRANSIT", // Alocată pentru ridicare
    24: "CANCELED", // Comandă anulată locker

    // Scheduling / Pickup later
    73: "PENDING", // Ridicare ulterioara

    // International Shipments
    30: "IN_TRANSIT", // În tranzit internațional
    31: "IN_TRANSIT", // În vamă
    32: "FAILED", // Blocat în vamă
  } as Record<
    number,
    | "REGISTERED"
    | "IN_TRANSIT"
    | "DELIVERED"
    | "CANCELED"
    | "FAILED"
    | "RETURNED"
    | "PENDING"
  >,

  // Romanian status labels
  statusLabels: {
    // Normal Delivery Flow
    1: "Comandă înregistrată",
    2: "În curs de ridicare",
    3: "Colet ridicat",
    4: "Ridicată de la client",
    5: "În depozit",
    6: "În curs de livrare",
    7: "Livrat",

    // Failed Delivery Attempts
    8: "Livrare eșuată",
    9: "Livrata cu succes",
    11: "Refuz de primire",

    // Cancellations and Issues
    15: "Comandă anulată",
    16: "Comandă respinsă",
    17: "Comandă expirată",

    // Locker/PUDO Services
    20: "În așteptare încărcare în easybox",
    21: "Încărcat în easybox",
    22: "Ridicat din easybox",
    23: "Alocată pentru ridicare",
    24: "Comandă anulată locker",

    // Scheduling / Pickup later
    73: "Ridicare ulterioara",

    // International Shipments
    30: "În tranzit internațional",
    31: "În vamă",
    32: "Blocat în vamă",
  } as Record<number, string>,

  calculateDeliveryProgress: (statusId: number): number => {
    const progressMap: Record<number, number> = {
      1: 0, // Order registered
      2: 15, // Pickup in progress
      3: 30, // Picked up
      4: 45, // Picked up from client
      5: 60, // In warehouse
      6: 85, // Out for delivery
      7: 100, // Delivered
      8: 85, // Delivery failed
      9: 100, // Delivered successfully
      11: 0, // Refused (regression to 0%)

      // Locker flow
      20: 20, // Waiting for locker load
      21: 60, // Loaded in locker
      22: 100, // Picked up from locker
      23: 30, // Allocated for pickup

      // International flow
      30: 40, // International transit
      31: 70, // In customs
      32: 50, // Held in customs
      73: 10, // Pickup later
    };
    return progressMap[statusId] ?? 0;
  },

  // Status grouping
  getStatusGroup: (
    statusId: number
  ): "active" | "completed" | "failed" | "cancelled" => {
    // Completed deliveries (successful delivery or locker pickup)
    if ([7, 9, 22].includes(statusId)) return "completed";

    // Failed deliveries (delivery attempts, refused, rejected, expired, locker failures, held in customs)
    if ([8, 11, 16, 17, 24, 32].includes(statusId)) return "failed";

    // Cancelled orders
    if ([15].includes(statusId)) return "cancelled";

    // Active shipments
    return "active";
  },
};
